module.exports = __webpack_public_path__ + "static/media/codingninjas_logo.a97e2bdd.png";